export default async (to, from, next) => {
    const middlewares = to.meta.middleware;
    if (!middlewares) return next();
    
    const runMiddlewares = async (middlewares) => {
        const [first, ...rest] = middlewares;
        if(!first) return next();
        try {
            const module = await import((`@/middlewares/${first}.js`));
            const middlewareFn = module.default;

            middlewareFn(to, from, (...args) => {
                if (args.length > 0) next(...args)
                else runMiddlewares(rest);
            });
        }catch(err) {
            console.error(err);
            next(false);
        }
    }
    
    await runMiddlewares(middlewares);
}
